import React, { useEffect, useState } from 'react'
import styles from "./exInventoryListing.module.css";
import BomListTable from '../../components/OtherComps/BomListTable/BomListTable'
import ExInventListTable from '../../components/OtherComps/ExInventListTable/ExInventListTable';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getMatchedProductsThunk } from '../../redux/bomSlice';
import WizardTable from '../../components/OtherComps/wizard/WizardTable';
import { Back } from '../../../Svg';
import { uploadVendorExcessThunk } from '../../redux/excessSlice';

const ExInventoryListing = () => {


    const { loading, macthedProducts, quantities } = useSelector((state) => state.bom)
    const [showLogin, setShowLogin] = useState(false)
    const { isLoggedin } = useSelector((state) => state.customer)
    const [submitLoading, setSubmitLoading] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = location.state

    console.log(macthedProducts);

    useEffect(() => {
        dispatch(getMatchedProductsThunk(data))
    }, [])
    // console.log(data);


    const handleSubmit = async (selectedProducts) => {
        setSubmitLoading(true)
        
        const datas = {
            partList: selectedProducts
        }
        const status = await dispatch(uploadVendorExcessThunk(datas))
        // Navigate back on success (fulfilled), regardless of exact payload value
        if (status?.meta?.requestStatus === 'fulfilled' && status?.payload) {
            navigate("/exInventoryUpload")
        }
        setSubmitLoading(false)
    }

    // console.log(macthedProducts);


    return (
        <>
            <div className={styles.imgBread}>
                <span>Excess Inventory</span>
            </div>
            <div className={styles.crossContainer}>


                <div className={styles.myList}>
                    <div >
                        <button className={styles.compBtn} onClick={() => navigate(-1)}><Back />Back to previous page</button>
                    </div>
                    {/* {showLogin &&
                        <div className={styles.displayFlex} style={{ marginTop: 20 }}>
                            <div className={styles.bell}>
                                <img src='assets/bell.png' />
                            </div >
                            <div className={styles.access}>
                                <span className={styles.popupuploadLink} onClick={() => navigate('/login')} style={{ cursor: 'pointer', color: '#512DA8' }}>Login</span>&nbsp; or &nbsp;
                                <span className={styles.popupuploadLink} onClick={() => navigate('/customerRegn')} style={{ cursor: 'pointer', color: '#512DA8' }}>Register</span>     to save this list for future use and access all of the myLists features.
                            </div>
                        </div>
                    } */}
                    {/*   <div className={styles.btns}>
                        <button className={styles.addBtn}>Add Parts</button>
                        <button className={styles.addBtn}>Download</button>
                    </div> */}
                </div>
                {loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
                        <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
                    </div>
                    :
                    <WizardTable
                        products={macthedProducts}
                        from={"excess"}
                        setShowLogin={setShowLogin}
                        isLoggedin={isLoggedin}
                        handleUpload={handleSubmit}
                        submitLoading={submitLoading}
                    />


                }
            </div>
        </>
    )
}

export default ExInventoryListing